export default "__VITE_ASSET__17a122a0__"